import FizConfig from "../FizConfig.ts";
import * as i18n from "../i18n.ts";
import * as FwDatas from "../FwDatas.ts";
import * as Fiz from "../util/Fiz.ts";
import {OS} from "../lib/os.ts"

import ApiServer from "../server/fizapilib.auto.ts";
import * as rrule from "../lib/rrule/rrule.js";
import * as rrulewriter from "../lib/rrule/rrule-writer.js";
//import  "../lib/rrule/rrule-writer.test.js";
import * as DateUtils from "../lib/DateUtils.ts";
import * as TimezoneUtils from "../lib/TimezoneUtils.ts";
import * as handlebars_family from "../handlebars_family.ts";
import IHasRecurrencyHelper from "../lib/IHasRecurrencyHelper.ts";
import ISharableByMember from "./objects/ISharableByMember.ts";
import  "./objects/TaskBeans.ts";
import  "./objects/TaskCategoryBean.ts";
import {recipeCategoriesSyncCache, recipeSyncCache} from "../mealplanner/mealplannerApi.ts";
import { protoExtend } from "../lib/ObjectUtil.ts";
import { addParams } from "../lib/url.ts";
import { PlaceCache } from "./objects/MapBeans.ts";
import { getIconFromMimeType } from "../lib/FileUtils.ts";

var
  getProfile = FwDatas.getProfile;

Object.assign(ApiServer.types.ServerBeanPrototype.prototype,{
  authorIsMe:function(){
    return FwDatas.getAccountId()===this.accountId;
  },
  author:function(){
    return getProfile(this.accountId);
  }
});


Object.assign(ApiServer.types.CalendarBean.prototype,ISharableByMember,{
  sharedBy(){
    if(this.sharedByAccountId){
      return i18n.getMustache("calendars.sharedBy",getProfile(this.sharedByAccountId));
    }
  },
  colorUI(){
    return this.color || FizConfig.defaultColor;
  },
  onDecode(){
    FwDatas.cache(this)
    if(this.type==="TASKS"){
      this.details = i18n.get("calendars.detailtask");
    }else if(this.type==='PUBLIC_HOLIDAYS_FOLDER' && this.countryCode){
      this.details = i18n.get("calendars.publicholidaysin", i18n.getCountry(this.countryCode,this.countryLang));
    }else{
      this.details = this.location;
    }
    if(this.type==="TIMETABLE"){
      this.subtitle = i18n.get("calendars.defaulttimetable",this.name);
      this.subtitlemodal = null;
    }else if(this.type==="MEALPLANNER"){
      this.subtitlemodal = null;
    }else{
      this.subtitlemodal = this.subtitle;
    }
    if(this.type==='PUBLIC_HOLIDAYS'){
      this.detailinfolder = i18n.get("calendars.publicholidays")
    }else if(this.type==='PUBLIC_HOLIDAYS_ONLY'){
      this.detailinfolder = i18n.get("calendars.publicholidaysonly")
    }else{
      this.detailinfolder = this.subtitle;
    }

    this.isFolderRadio = this.type==='PUBLIC_HOLIDAYS_FOLDER';

    this.useCalendarColor = !this.useEventColor;

    this.subtitlewithsub = this.subtitle;
    if(this.calendars){
      var activatedSub = this.calendars.filter(c=>c.activated);
      for(var i=0;i<activatedSub.length;i++){
        this.subtitlewithsub += (i==0)?" - ":", ";
        this.subtitlewithsub += activatedSub[i].subtitle;

      }
    }
  },
  openSettingsOnActivate(){
    if(this.activated) return false;
    if(this.calendars){
      for(let i=0;i<this.calendars.length;i++){
        if(this.calendars[i].activated) return false;
      }
      return true;
    }
    return false;
  },

  clickaction(){
    //if activated can deactivate
    if(this.activated){
      return "evtcalactivate|"+this.metaId+"|false";
    }
    //set all stuff to subcalendars
    if(this.calendars){
      for(let i=0;i<this.calendars.length;i++){
        if(this.calendars[i].activated){
          return "evtcalactivate|"+this.metaId+"|true";
        }
      }
      return "caledit|"+this.metaId;
    }
    //activate
    return "evtcalactivate|"+this.metaId+"|true";
  }
});
Object.assign(ApiServer.types.CalendarTimetableBean.prototype,ApiServer.types.CalendarBean.prototype);

Object.assign(ApiServer.types.RecurrencyDescriptor.prototype,{
  worthDisplaying(){
    return this.recurrency!=='NONE';
  },
  text(){
    if(this.recurrency!=='NONE'){
      var options = rrule.RRule.parseString(this.rrule);
      if(this.allDay){
        //l'heure d'été à aukland met la zone alors on s'assure qu'on sera bien le bon jour avec cette bidouille
        if(options.until){
          options.until = new Date(options.until.toISOString().substring(0,10)+'T23:59:59')
        }
      }
      try{
        return rrulewriter.write(options);
      }catch(e){
        console.log(e);
        return "";
      }
    }
  }

});

function extendPrototype<T>(prototype, ... methods :{[key:string]:(this:T)=>any}[]){
  Object.assign(prototype,... methods)
}
extendPrototype<IReminder>(ApiServer.types.IReminder.prototype,{
  text(forType,allDay){
    return ApiServer.types.IReminder.html(this.reminderUnit,this.reminderValue,forType,allDay);
  },
  simple(){
    return this.reminderType==='NONE'?"":this.reminderUnit+'-'+this.reminderValue;
  }
});
ApiServer.types.IReminder.html = function(unit,value,type,allDay){
  if(!unit){
    return i18n.get('reminder.none');
  }
  if(value===0){
    if(type==="task"){
      return i18n.get('reminder.atduedate');
    }else if(allDay){
      //return i18n.get('reminder.ateventallday');
    }else{
      return i18n.get('reminder.atevent');
    }
  }
  if(allDay){
    let
      twentyHeightOfMonth = DateUtils.dateSet(new Date(),{day:28,hour:9,minute:0,second:0,milli:0}),
      timeOfNotif,
      delta = {},
      dayDiff;
    delta[unit.toLowerCase()] = -value;

    timeOfNotif = DateUtils.dateAdd(twentyHeightOfMonth,delta);
    dayDiff = twentyHeightOfMonth.getDate()-timeOfNotif.getDate()

    if(dayDiff===0){
      return i18n.get('reminder.ateventday',DateUtils.format(timeOfNotif,'LT'));
    }else if(dayDiff === 1){
      return i18n.get('reminder.atevent1daybefore',DateUtils.format(timeOfNotif,'LT'));
    }else if(dayDiff === 2){
      return i18n.get('reminder.atevent2daybefore',DateUtils.format(timeOfNotif,'LT'));
    }else if(dayDiff >= 3){
      return i18n.get('reminder.ateventNdaybefore',{n:dayDiff,time:DateUtils.format(timeOfNotif,'LT')});
    }else{
      //must not happen
      return "";
    }
  }
  let unitKey;
  if(value>1){
    unitKey = {
      HOUR:"timeunit.hours",
      DAY:"timeunit.days",
      MINUTE:"timeunit.minutes"
    }[unit];
  }else{
    unitKey = {
      HOUR:"timeunit.hour",
      DAY:"timeunit.day",
      MINUTE:"timeunit.minute"
    }[unit];
  }
  return i18n.getMustache('reminder.text',{unit:i18n.get(unitKey),value:value});

}


/**
 * IM
 */

Object.assign(ApiServer.types.IIMThread.prototype,{

  isunRead(){
    for(var i=0,len=this.participants.length;i<len;i++){
      var participant = this.participants[i];

      if(participant.isLogguedAccount){
        return participant.lastReadMessageDate==null ||
          (participant.lastReadMessageDate < this.messageListModifDate);
      }
    }
  },
  //use this when marking as read and do not want to refresh
  markAsRead(){
    this.isunRead=function(){return false;};
  }
});


function formatDisplayDate(mom,useToday = true){

  if (useToday && DateUtils.isToday(mom) ){
    return i18n.get("event.today");
  }

  if (useToday && DateUtils.isTomorrow(mom) ){
    return i18n.get("event.tomorrow");
  }

  return DateUtils.format(mom,'dddd LL');

}

Object.assign(ApiServer.types.IEvent.prototype,{
  listInterval(range){
    return IHasRecurrencyHelper.listInterval(this,range).map(event=>{
      if (event.isBirthday){
        event.personAge = event.occurenceIndex;
        if(event.occurenceIndex===0){
          event.text = handlebars_family.i18n("event.displayAge0",event,true);
        }else{
          event.text = handlebars_family.i18n("event.displayAge",event,true);
        }
        event.title = event.text;
      }

      return event;
    });
  },
  isDefaultCalendar(){
    return this.calendarId.indexOf('calendar/')===0;
  },

  cartridgeLeft(){
    var
      top = null;
    if(DateUtils.isToday(this.start)){
      top = i18n.get('event.today');
    }else if(DateUtils.isTomorrow(this.start)){
      top = i18n.get('event.tomorrow');
    }
    if(top===null||this.allDay){
      var
        contentMonth = '<p style="font-size:16px;line-height:24px">'+DateUtils.format(this.start,'MMMM')+'</p>',
        contentDay = '<p style="font-size:40px;line-height:40px">'+DateUtils.format(this.start,'D')+'</p>';
      //replace replace only the first which is expected
      return contentMonth+contentDay;
    }else{
      return '<p style="background-color:#BBBBBB;color:#FFF;font-size:80%;line-height:200%;width:100%;text-align:center">'+top+'</p><p class="flexauto" style="margin-top:10px;">'+DateUtils.format(this.start,'LT')+'</p>';
    }

  },

  onDecode(json){
    this.json = json;
    TimezoneUtils.preferredTimezone.add(this.timeZone)
    //for event comming from wall
    FwDatas.cache(this)

    this.rights = this.editable?{canDelete:true,canUpdate:true}:{};

    this.recurrencyDescriptor.allDay = this.allDay;
    if (this.allDay){
      this.start = this.startDate = new Date(json.startDate.substring(0,19));
      this.end = this.endDate = json.endDate?new Date(json.endDate.substring(0,19)):this.startDate;

      if(this.recurrencyDescriptor.exdate){
        this.recurrencyDescriptor.exdate = this.recurrencyDescriptor.exdate.map((exdate)=>{
          return new Date(exdate.toISOString().substring(0,19));
        });
      }

    }else{
      this.start = this.startDate;
      this.end = this.endDate;

    }
    this.isBirthday = (
        this.eventType === "BIRTHDAY_CUSTOM" ||
        this.eventType === "BIRTHDAY" ||
        this.eventType === "BIRTHDAY_ACCOUNT"
    );
    if (this.isBirthday){
      this.personAge = this.occurenceIndex;
      this.personName = this.refPersonName ||this.text;
      if(this.occurenceIndex===0){
        this.text = handlebars_family.i18n("event.displayAge0",this,true);
      }else{
        this.text = handlebars_family.i18n("event.displayAge",this,true);
      }
    }

    if(this.eventType === "BIRTHDAY_ACCOUNT"){
      this.toAll = false;
      this.attendeeIds = [this.accountId]
    }

    // Event Object for FullCalendar
    //this.id = this.eventMasterId; // same id for repeating events
    this.title = this.text;
    this.colorDB = this.color;
    if(this.color && this.color.length>7){
      this.color = this.color.substring(0,7);
    }
    var attendees = this.attendees = [];
    if(this.attendeeIds){
      this.attendeeIds.forEach(function(id){
        attendees.push({author:getProfile(id),accountId:id})
      })
    }
    if(!this.toAll && this.attendees.length==1){
      this.colorAttendee = this.attendees[0].author.color
    }
    this.colorUI = this.colorDB || this.colorAttendee || (this.calendar?this.calendar.color:null) || FizConfig.defaultColor;

    if(this.placeId){
      this.place = PlaceCache.get(this.placeId);
      if(!this.where && this.place){
        this.where = this.place.name;
      }
    }

    if(this.eventType==='EXTERNAL'){
      this.author = null;
    }
    this.picture = this.medias&&this.medias.length?this.medias[0].pictureUrl:null;
    this.commentable = this.calendarId.indexOf('calendar/')===0;
    this.isTimetableEvent = this.calendarId.indexOf('calendarTimetable/')===0;
    this.isMealplannerEvent = this.calendarId.indexOf('calendarMealPlanner/')===0;
    this.isBudgetEvent = this.calendarId.indexOf('calendarBudget/')===0;
    this.draggable = this.editable && (!this.isTimetableEvent)&& (!this.isMealplannerEvent)
  },
  hasItsOwnRecurrency(){
    if(this.isTimetableEvent){
      //if it is not oneTime timetable, the recurrency comes from the timetable
      if(this.calendar.timetable?.recurrencyDescriptor.recurrency!=='NONE'){
        return false;
      }
    }
    return this.recurrencyDescriptor.recurrency!=='NONE'
  },
  timetableWeekName(){
    if(!this.isTimetableEvent){
      return null;
    }
    if(this.calendar.timetable.isOneTime){
      return null;
    }
    var
      startWeek = this.calendar.timetable.getWeek(this.start),
      endWeek = this.calendar.timetable.getWeek(this.end);

    if(startWeek==endWeek){
      return startWeek.name;
    }
    return i18n.get('timetable.week')+' '+[startWeek,endWeek].map(week=>week.letter).join(' & ');
  },
  reminder0(){
    return this.reminderList[0];
  },
  reminder1(){
    return this.reminderList[1];
  },
  reminder2(){
    return this.reminderList[2];
  },
  i18ndateformat(){
    this.buildDisplayInCalendar()
    if(this.displayStartDate === this.displayEndDate){
      if (this.allDay){
        return i18n.getMustache("event.singleDayAllDayFormat",this);
      } else if (this.displayStartTime === this.displayEndTime){
        return i18n.getMustache("event.pinpointDateFormat",this);
      } else {
        return i18n.getMustache("event.singleDayFormat",this);
      }
    } else{
      if (this.allDay){
        return i18n.getMustache("event.multipleDayAllDayFormat",this);
      } else {
        return i18n.getMustache("event.multipleDayFormat",this);
      }
    }
  },
  isAttendee(idAsLong){
    return this.toAll || this.attendeeIds.indexOf(idAsLong)>-1 ;
  },

  buildDisplayInCalendar(){
    this.displayStartTime = DateUtils.format(this.start,'LT');
    this.displayStartDate = formatDisplayDate(this.start,true);

    this.displayEndTime = DateUtils.format(this.end,'LT');
    this.displayEndDate = formatDisplayDate(this.end,true);

    if(this.isTimetableEvent){
      this.displayStartDate =  DateUtils.format(this.start,'dddd');
      this.displayEndDate =  DateUtils.format(this.end,'dddd');

    }else{
      //if two distinct day we do not want today or tomorrow because it might cause weird stuff
      if(this.displayStartDate === this.displayEndDate){
        this.displayStartDate = formatDisplayDate(this.start,false);
        this.displayEndDate = formatDisplayDate(this.end,false);
      }
    }


  },
  timezonedinfo(){
    if(this.hasTimezone()){
      return {
        timeZone:this.timeZone,
        start:TimezoneUtils.toZone(this.start,this.timeZone),
        end:TimezoneUtils.toZone(this.end,this.timeZone),
        buildDisplayInCalendar:this.buildDisplayInCalendar,
        i18ndateformat:this.i18ndateformat,

      }
    }
  },
  hasTimezone(){
    return this.timeZone && this.timeZone !== OS.getTimeZone()
  }
});


function paginateComments(activity){
  if(!activity.comments || ! activity.comments.length){
    return;
  }
  activity.comments.sort(function(a,b){
    return a.creationDate - b.creationDate;
  });
  var
    accountId = FwDatas.getAccountId(),
    hideIdx = activity.comments.length-2;
  activity.comments.forEach(function(comment,idx){
    comment.editable = activity.editable || comment.accountId===accountId;
    comment.hidden = (idx<hideIdx);
  });
  activity.totalComments = activity.comments.length;
  activity.hasHiddenComments = ( hideIdx > 0 );
  activity.hasMaxComments = ( activity.totalComments >= 1000 );

}

Object.assign(ApiServer.types.IWallMessage.prototype,{
  refActionData(){
    if(this.type === 'event' || this.type === 'task'){
      return;
    }
    if(this.refAction==='COMMENTED'){
      return {text:i18n.get('refAction.commented'),author:getProfile(this.postAccountId),date:this.sortingDate};
    }else if(this.refAction==='MOOD_STAR'){
      return {text:i18n.get('refAction.liked'),author:getProfile(this.postAccountId),date:this.sortingDate};
    }
  },
  family(){
    return FwDatas.getFamily();
  },
  onDecode(json){
    decodeGiphy(this);
    var
      contact,
      // map of refType => CSS class for styling
      ACTIVITY_TYPES = {
        MESSAGE_THREAD:'message',
        PLACE_IN:'location',
        PLACE_OUT:'location',
        EVENT:'event',
        EVENT_CREATED: 'event',
        EVENT_UPDATED: 'event',
        EVENT_DELETED: 'event',
        EVENT_COMMENTED: 'event',
        TASKLIST: 'list',
        TASK_CREATED: 'task',
        TASK_UPDATED: 'task',
        TASK_COMMENTED: 'task',
        TASK_ASSIGNED: 'task',
        TASK_MARKED_COMPLETED: 'task',
        STATUS:'status',
        SINGLE_PICTURE: 'pictures',
        MULTIPLE_PICTURE: 'pictures',
        SINGLE_PICTURE_COMMENTED: 'pictures',
        MULTIPLE_PICTURE_COMMENTED: 'pictures',
        ORANGE_VVM_VOICE_MSG: 'amy',
        ORANGE_VVM_MISSED_CALL: 'amy',
        ORANGE_THUNDERSTORM_ALERT: 'amy',
        FAMILY_CREATED: 'settings',
        INVITATION_SENT: 'settings',
        MEMBER_JOIN: 'settings',
        PROFILE_CHANGED: 'settings',
        ACCOUNT_DELETED: 'settings'
      };
    this.id = this.wallMessageId;
    paginateComments(this);
    // activity type is used as a CSS class for styling
    this.type = ACTIVITY_TYPES[this.refType]||"hide";
    this["is"+this.type.charAt(0).toUpperCase()+this.type.slice(1)] = true;
    this["isRefType"+this.refType] = true;

    if(!this.isEvent){
      mapMedia(this);
    }

    this.isMoodable = this.refType !== 'FAMILY_CREATED';
    this.isCommentable = this.refType !== 'FAMILY_CREATED';

    if(this.type==='location' && this.refId && !this.place){
      this.place = FwDatas.get(this.refId);
    }
    this.timestamp = this.creationDate;
    if(this.isEvent){
      if(this.event.isBirthday){
        this.isBirthday = true;
      }
      this.timestamp = this.event.startDate;
      this.event.comments = null;
    }
    if (this.isSettings){
      // another family member, different from the author
      this.person = getProfile(this.refId);
      if((this.person===undefined ||this.person===null ) && this.extra){
        this.person = this.extra.profile;
      }
      // a single contact
      if(this.extra){
        if((contact = this.extra.contact)){
          this.contactId = contact.id;
          this.contactName = contact.name;
          this.contact = FwDatas.get(this.contactId);
        }
        if(this.extra.contacts){
          this.contactNames = this.extra.contacts.map(contact=>contact.name).join(", ");
        }
      }
    }
    FwDatas.cacheWall(this);
    this.editable = json.editable?this.editable:FwDatas.getAccountId()===this.accountId;
  }
});



Object.assign(ApiServer.types.IComment.prototype,{
  likers(){
    var
      currentAccountId = FwDatas.getAccountId().toString(),
      res = Object.entries(this.moodMap).map(([accountId,mood])=>{
        if(currentAccountId===accountId) return;
        if(mood.indexOf('STAR')!==-1){
          return getProfile(accountId);
        }
      }).filter(prof=>prof!==undefined);

    if(res.length>5){
      var
        iconText = "+"+(res.length-3),
        toAdd = {thumb:Fiz.getDefaultUrl(iconText.length===2?iconText:iconText.substring(1),"#cccccc")},
        removed = res.splice(3,res.length-3,toAdd);
      toAdd.name = removed.map(v=>v.name).join(', ');
    }
    return res;

  },
  onDecode(){
    this.metaId = this.commentId;
    if(this.mood==='STAR'){
      this.text = '❤';
    }
    decodeGiphy(this);
    FwDatas.cache(this);
  }
});

Object.assign(ApiServer.types.PremiumRightBean.prototype,{
  requestlocation(){
    return this.geoLocAvailable?true:"takepremium";
  },
  requestautotrack(){
    return this.geoLocAvailable?true:"takepremium";
  },
  modalcreatecircleonClickAction(){
    return {
      OK:'modalcreatecircle',
      KO_LIMIT:'createcirclequotareached'
    }[this.canFoundFamily];
  },
  addplaceOnClickAction(){
    return {
      OK:'addplace'
    }[this.canCreatePlace];
  },
  inviteOnClickAction(){
    return {
      OK:'invitemenu',
      KO_LIMIT:'invitequotareached',
    }[this.canInvite]||false;

  },
  googleconnect(){
    return {
      OK:'googleconnect',
      KO_PREMIUM:'takepremium'
    }[this.canLinkGoogleCalendar];
  },
  icsconnect(){
    return {
      OK:'icsconnect',
      KO_PREMIUM:'takepremium'
    }[this.canLinkCalendarByUrl];

  },
  aiinbox(){
    return {
      OK:'aiinboxmodal',
      KO_PREMIUM:'takepremium'
    }[this.aiImport];
  },
  outlookconnect(){
    return {
      OK:'outlookconnect',
      KO_PREMIUM:'takepremium'
    }[this.canLinkOutlookCalendar];
  },
  mpadditemtolist(){
    return {
      OK:'mpadditemtolist',
      KO_PREMIUM:'takepremium'
    }[this.recipeExportToShoppingListFlag];
  },
  recipecatlist(){
    return {
      OK:'recipecatlist',
      KO_PREMIUM:'takepremium'
    }[this.recipeCustomCategoriesFlag];
  },
  specialdayscreate(){
    return this.specialDays?true:'takepremium';
  },
  specialdaysedit(){
    return this.specialDays?'eventedit':'takepremium';
  },
  specialdayscopy(){
    return this.specialDays?true:'takepremium';
  }


});
export function birthDateBean(this : {birthDate:Date,birthDateNoYear:boolean}){
  if(this.birthDate){
    const
      birthDateDisplay = this.birthDateNoYear?DateUtils.format(this.birthDate,"DM"):DateUtils.format(this.birthDate,"LL"),
      birthDateLocal = DateUtils.getNextBirthday(this.birthDate),
      deltaDays =  DateUtils.getDeltaDays(birthDateLocal);

    return {
      birthDateDisplay,
      deltaDays,
      labelDays:deltaDays>1?'timeunit.days':'timeunit.day'
    }
  }
}
Object.assign(ApiServer.types.IProfile.prototype,{
  onDecode(json){
    this.name = this.firstName;
    this.birthDateBean = birthDateBean
  },
  toString : function(){
    return this.name;
  }
});
Object.assign(ApiServer.types.IFamily.prototype,{
  onDecode(){
    var family = this;
    this.picture = this.pictureUri;
    family.user = this.members.find(member=>member.isloggedaccount)
    this.members.sort(function(a,b){
      if(b.isloggedaccount){
        return 1;
      }
      if(a.isloggedaccount){
        return -1;
      }
      if(a.right!==b.right){
        var pointsMap = {Admin:2, SuperAdmin:3, SubAccount:1};
        return (pointsMap[b.right]||0) - (pointsMap[a.right]||0);
      }
      //firstname is on in IExtendedFamilyMember not in IFamilyMember 
      //this method is called via .super in IExtendedFamily so this ||'' avoid a NPE
      return (a.firstName||'').localeCompare((b.firstName||''))
    })
    this.members.forEach(function(member){
      // is user allowed to edit member details
      member.isEditable = (family.user?.isAdmin) || member.isloggedaccount;
      // is user allowed to grant/revoke administration rights of member
      member.isAdminEditableDisabled = member.isFamilyFounder || !family.user?.isAdmin;
    });
  }
});
Object.assign(ApiServer.types.IFamilyMember.prototype,{
  onDecode(){
    this.hasJoined = (this.joinDate!==undefined);
    this.isFamilyFounder = this.isAdmin = false;
    switch (this.right){
      case "SuperAdmin":
        this.isFamilyFounder = true;
        this.isAdmin = true;
        break;
      case "Admin":
        this.isAdmin = true;
        break;
    }
  }
});
Object.assign(ApiServer.types.IExtendedFamilyMember.prototype,{
  onDecode(json){
    ApiServer.types.IFamilyMember.prototype.onDecode.call(this);
    ApiServer.types.IProfile.prototype.onDecode.call(this,json);
    if(this.isloggedaccount){
      if (this.locale ){
        this.languageCode = this.locale.replace("_","-");
      }
      if(!this.identifiers.find(id=>id.type==='Email')){
        this.askEmail = true
      }
    }

    this.devices.sort(function(a,b){
      return a.deviceType.localeCompare(b.deviceType) || (a.deviceId||'').localeCompare(b.deviceId||'');
    });
    this.login = this.identifiers.find(identifier=>identifier.type==='Login'||identifier.type==='Email')?.value
    var roleText = []
    if(this.isFounder){
      roleText.push(i18n.get('accountType.SuperAdmin'))
    }else if(this.isAdmin){
      roleText.push(i18n.get('accountType.Admin'))
    }
    if(this.role==='Unknown'){
    }else if(this.role==='Custom'){
      roleText.push(this.customRole);
    }else{
      roleText.push(i18n.get('role.'+this.role))
    }
    this.roleText = roleText.join(' & ')
  },
  isKid(){
    if(this.birthDate){
      if(DateUtils.computeAge(this.birthDate)<13) return true;
    }
    return this.identifiers.find(identifier=>identifier.type==='Email')==undefined
  },
  devicesForupdate(){
    var hasPhone, hasEmail, result = this.devices;
    this.devices.forEach(function(device,idx){
      if(device.deviceType==='EMAIL'){
        hasEmail = true;
      }else{
        hasPhone=true;
      }
    });
    if(!hasPhone){
      result = [{deviceType:'MOBILE'}].concat(result);
    }
    if(!hasEmail){
      result = result.concat([{deviceType:'EMAIL'}]);
    }

    return result;
  },


  toString(){
    return this.name;
  }
});
Object.assign(ApiServer.types.IExtendedFamily.prototype,{
  onDecode(json){
    ApiServer.types.IFamily.prototype.onDecode.call(this);

  }
});

function Gallery(){
  this.pictures = [];
  this.videos = [];
  this.audios = [];
}
Gallery.prototype.lines = function(){
  var
    line = {items:[],ratioX:0},
    result = [line],
    medias = this.medias.filter(media=>media!==null && media.mimeType.indexOf('audio') !== 0);

  for(var i=0;i<medias.length;i++){
    if(line.ratioX>2.65 && i<medias.length-1){
      line = {items:[],ratioX:0};
      result.push(line)
    }
    line.ratioX += medias[i].ratioX();
    line.items.push(medias[i]);
  }
  //calculated width for each item
  result.forEach(function(line,idx){
    if(idx>1){
      line.hidden = true;
    }
    for(var i=0;i<line.items.length;i++){
      var item = line.items[i];
      if(line.items.length>1){
//        line.items[i].widthPercent = (Math.max(1,(8/3)/line.invertedRatio))*50 /(4 /3*line.items[i].ratio());
        item.widthPercent = 100*item.ratioX()/line.ratioX;
        item.thumbUrl=item.url(512,512,'r');
      }else{
        item.thumbUrl=item.url(1024,1024,'r');
        item.widthPercent ="";
      }
    }
  });
  return result;

}

var giphymatcher =  /https?:\/\/[^\s()‘’“”«»]*/g;
function decodeGiphy(obj){
  if(!obj.text) return;
  var giphy = [];
  obj.textraw = obj.text.replace(giphymatcher,function(match){
    if(match.indexOf('giphy.com')>0 || match.indexOf('gph.is')>0){
      giphy.push(match);
      return '';
    }else{
      return match;
    }
  }).trim();
  obj.giphy = giphy;

}
function mapMedia(iHasMedia){
  if(iHasMedia.medias && iHasMedia.medias.length){
    var g = iHasMedia.gallery = new Gallery();
    g.medias=iHasMedia.medias;
    iHasMedia.medias.forEach(function(media) {
      if(media===null){
        //extra security
      }else if (media.mimeType.indexOf('video') === 0) {
        g.videos.push(media);
      }else if(media.mimeType.indexOf('audio') === 0) {
        g.audios.push(media);
      }else{
        g.pictures.push(media);
      }
    });
    g.length = g.pictures.length+g.videos.length+g.audios.length;
    if(g.videos.length===g.length){
      g.notificationkey = g.length>1?'notifications.NEW_VIDEOS':'notifications.NEW_VIDEO';
    }else if(g.pictures.length===g.length){
      g.notificationkey = g.length>1?'notifications.NEW_PICTURES':'notifications.NEW_PICTURE';
    }else if(g.audios.length===g.length){
      g.notificationkey = g.length>1?'notifications.NEW_AUDIOS':'notifications.NEW_AUDIO';
    }else{
      g.notificationkey = 'notifications.NEW_MEDIAS';
    }
  }
}


var idxColor = 0;
Object.assign(ApiServer.types.IMedia.prototype,{
  isVideo(){
    return this.mimeType.indexOf('video/')===0;
  },
  isIframable(){
    return this.mimeType.indexOf('application/pdf')===0 || this.mimeType.indexOf('text/plain')===0;
  },
  isImage(){
    return this.mimeType.indexOf('image/')===0;
  },
  isAudio(){
    return this.mimeType.indexOf('audio/')===0;
  },
  cannotDisplay(){
    return !this.isVideo()&&!this.isImage()&&!this.isIframable()&&!this.isAudio()
  },
  ratio(){
    return this.resolutionY/this.resolutionX;
  },
  ratioX(){
    return this.resolutionX/this.resolutionY;
  },
  getLimitedRatio(): number {
    var ratio = this.ratioX() || 1;
    if(ratio<0.7) ratio = 0.7;
    if(ratio>1.7) ratio = 1.7;
    return ratio;
  },
  getFlexBasis(height: number): number {
    return Math.round(height*this.getLimitedRatio())
  },

  editable(){
    return (this.pointedByWhat==="wall"||this.pointedByWhat==="family") && (this.accountId===FwDatas.getAccountId() || FwDatas.getUser().isAdmin);
  },
  url(w,h,s){
    //we want true url
    if(!w){
      return this.pictureUrl;
    }
    if(typeof s!=='string'||s.length!==1){
      s='c';
    }
    //we want bigger than the file we can just ask the file
    //FWS-957 chek on resolutionX/Y because weirdly 12>null
    if(s==='r' && this.resolutionX && this.resolutionY && w>this.resolutionX && h>this.resolutionY){
      //if it is a video we do not want the video but the preview
      if(this.isVideo()){
        return this.pictureUrl+'w='+this.resolutionX+'&h='+this.resolutionY+'&s='+s;
      }else{
        return this.pictureUrl;
      }
    }
    return this.pictureUrl+'w='+w+'&h='+h+'&s='+s;
  },
  iconsimple(css){
    return `<icon style="${css}">${this.icon}</icon>`
  },
  size(){
    var unit = 0, crawler = this.datasize;
    while(crawler>1000){
      unit++;
      crawler /= 1000;
    }
    if(crawler<10){
      crawler = Math.round(10*crawler)/10;
    }else{
      crawler = Math.round(crawler);
    }
    return crawler+i18n.get("sizeunit."+['B','KB','MB','GB','TB'][unit]);
  },
  fitToScreen(){
    if(!this.resolutionX || !this.resolutionY) return this;
    var
      maxWidth = (Math.ceil(window.screen.availWidth/512)*512),
      maxHeight = (Math.ceil(window.screen.availHeight/512)*512);
    if(this.resolutionX>maxWidth || this.resolutionY>maxHeight){
      var
        reduceRatio = Math.min(maxWidth/this.resolutionX,maxHeight/this.resolutionY);
      return protoExtend(this,{
        pictureUrl:addParams(this.pictureUrl,{w:maxWidth,h:maxHeight,s:'r'}),
        resolutionX:this.resolutionX*reduceRatio,
        resolutionY:this.resolutionY*reduceRatio,
        ratio:this.resolutionX/this.resolutionY
      })
    }
    return this;
  },
  onDecode(json){
    FwDatas.cacheIMedia(this)
    if(!this.mimeType){
      this.mimeType = "";
    }
    if(!this.color){
      this.color = ["#CAD6D7","#CACED1","#D5D6D4","#D6D4CC","#CFCBC4"][idxColor++ %5];
    }
    //icon
    this.icon = getIconFromMimeType(this.mimeType);

    if(this.filerModifDate==null){
      this.filerModifDate = this.creationDate;
    }
  }


});




ApiServer.types.MealSettingsBean.prototype.onDecode=function(){
  var _this = this;
  this.visibleColumns = this.columns.filter(function(c){
    c.displayName = c.name||i18n.get("mp.cols")[c.type];
    c.optional = (c.type==="CUSTOM1"||c.type==="CUSTOM2") && !c.name && !c.display;
    _this.hasOptional |= c.optional;
    if(c.emoji==='🍽') c.emoji='🍽️'; //rewrite with colored one emoji
    return c.display;
  })
  this.visibleColumns.sort(function(a,b){return a.timeSlot<b.timeSlot?-1:1})
}

ApiServer.types.RecipeInputBean.prototype.onDecode=function(json){
  try{
    this.host = new URL(this.url).hostname;

  }catch(e){}

  this.totalTime = 0;
  if(this.cookTime){
    this.totalTime += this.cookTime;
    this.cookMin = this.cookTime%60;
    this.cookHour = (this.cookTime - this.cookMin) /60;
  }
  if(this.prepTime){
    this.totalTime += this.prepTime;
    this.prepMin = this.prepTime%60;
    this.prepHour = (this.prepTime - this.prepMin) /60;
  }
  if(this.totalTime){
    this.totalMin = this.totalTime%60;
    this.totalHour = (this.totalTime - this.totalMin) /60;
  }
  let thiz = this;
  this.categories = function(){
    return recipeCategoriesSyncCache.datas.map(trueCat=>{
      return {
        assigned:thiz.recipeCategoryIdList && thiz.recipeCategoryIdList.indexOf(trueCat.metaId)>-1,
        category:trueCat
      }
    }).filter(catContainer=>catContainer.category.categorySystem!=="FAVORITE")
  }

}
const
  FIZRIGHTALL = new ApiServer.types.FizRightBean({"canDelete":"true","canUpdate":"true"}),
  FIZRIGHTNONE = new ApiServer.types.FizRightBean({"canDelete":"false","canUpdate":"false"});

ApiServer.types.RecipeBean.prototype.onDecode=function(json){
  this.originalJson = json;
  if(!this.rights){
    this.rights = {};
  }
  this.clone = function(){return new ApiServer.types.RecipeBean(json)}
  this.isMoodable = true;
  this.color = this.ingredients===undefined?"#eee":FizConfig.defaultColor;
  if(this.medias && this.medias.length){
    this.thumb = this.medias[0].url(120,120,'c');
  }
  this.canShare = true;
  this.canMood = true;
  //repair default values
  if(this.isMealSuggestion===null){
    this.isMealSuggestion = true;
  }
  if(this.isRecipe===null){
    this.isRecipe = false;
  }
  this.hasDetails = !!this.ingredients || !!this.description || !!this.instructions;

  let thiz = this;
  this.hasCategories =function(){
    return thiz.categories().filter(cat=>cat.assigned).length;
  }
  this.moodStarShortcut =function(){
    let catFavorite = recipeCategoriesSyncCache.datas.filter(category=>category.categorySystem==="FAVORITE")[0];
    return catFavorite && thiz.recipeCategoryIdList.indexOf(catFavorite.metaId)!==-1;
  }
  this.setFavorite =function(add){
    var
      favId = recipeCategoriesSyncCache.datas.filter(category=>category.categorySystem==="FAVORITE")[0].metaId,
      idx = thiz.recipeCategoryIdList.indexOf(favId);
    if(add && idx===-1){
      thiz.recipeCategoryIdList.push(favId);
    }
    if(!add && idx!==-1){
      thiz.recipeCategoryIdList.splice(idx,1);
    }
  }

  ApiServer.types.RecipeInputBean.prototype.onDecode.apply(this,[json])
}
ApiServer.types.RecipeBean.prototype.likers = ApiServer.types.IComment.prototype.likers;
ApiServer.types.RecipeExternalBean.prototype.onDecode=function(json){
  ApiServer.types.RecipeInputBean.prototype.onDecode.apply(this,[json])

  this.medias = this.images.map(openGraphMediaBean=>{
    openGraphMediaBean.pictureUrl = openGraphMediaBean.secureUrl;
    openGraphMediaBean.url = function(){return this.pictureUrl}
    return openGraphMediaBean;
  })
}

ApiServer.types.DishRangeBean.prototype.onDecode=function(){
  this.list.sort(function(a,b){return a.sortingIndex-b.sortingIndex})
}

ApiServer.types.DishBean.prototype.onDecode=function(json){
  FwDatas.cache(this);
  //TODO remove this when the sevrer will send the datas
  if(this.rights===undefined){
    this.rights=FIZRIGHTALL;
  }
}
Object.defineProperty(ApiServer.types.RecipeBean.prototype, "icon", {
  get() {
    if(this.medias.length>0){
      return "<img src='"+this.medias[0].url(120,120,'c')+"'/>"
    }
  }
});


Object.defineProperty(ApiServer.types.DishBean.prototype, "icon", {
  get() {
    return recipeSyncCache.get(this.recipeId)?.icon;
  }
});

ApiServer.types.TimetableBean.prototype.onDecode = function(json){
  this.isOneTime = this.recurrencyDescriptor.recurrency === 'NONE';
  this.isByUrl = this.icalSubscriptionUrl!==undefined;
  if(!this.isOneTime){
    this.startDate = new Date(json.startDate.substring(0,10)+'T00:00');
    this.startDateUtc = new Date(json.startDate);
    this.endDate = new Date(json.endDate.substring(0,10)+'T00:00');
    this.finishDate = new Date(json.finishDate.substring(0,10)+'T00:00');
    this.multiWeek = this.recurrencyDescriptor.recurrencyInterval>1;
    this.weeks = this.buildWeeks();
  }
  this.sharingType = this.sharedToAll?'all':(this.sharedMemberIds.length>1?'custom':'none');
  //FIXME it should never happen
  if(this.rights===undefined){
    this.rights=FIZRIGHTNONE;
  }
  this.rights.canShare = this.accountId === FwDatas.getAccountId()
}
ApiServer.types.TimetableBean.prototype.buildWeeks = function(){
  var
    result = [],
    weekCount = this.recurrencyDescriptor.recurrencyInterval,
    days = DateUtils.getWeekDays(this.calendarFirstDayOfWeek%7),
    crawlerWeek = this.startDate,
    crawlerDay = new Date(this.startDate);

  for(var i=0;i<weekCount;i++){
    var
      weekEnd = new Date(crawlerWeek),
      letter = String.fromCharCode(65+((i+this.firstOccurrenceOffset)%weekCount));
    weekEnd.setDate(weekEnd.getDate()+7)
    result.push({
      name:i18n.get('timetable.week')+' '+letter,
      index:i,
      letter:letter,
      start:crawlerWeek,
      end:weekEnd,
      days:days.map(dayInfo=>{
        //server does not accept date before the utcDate but in this case it should so I fixed like this
        let day = {index:crawlerDay.getDay(),name:dayInfo.name,value:DateUtils.forInputDate( crawlerDay)};
        crawlerDay.setDate(crawlerDay.getDate()+1)
        return day;
      })
    })
    crawlerWeek = weekEnd;
  }

  var
    currentWeekSeeker = new Date(),
    deltaWeekCount = 0;
  //firt of all we position our crawler in the range
  while(currentWeekSeeker<result[0].start){
    currentWeekSeeker = DateUtils.dateAdd(currentWeekSeeker,{day:7*weekCount});
  }
  while(currentWeekSeeker>result[result.length-1].end){
    currentWeekSeeker = DateUtils.dateAdd(currentWeekSeeker,{day:-7*weekCount});
  }
  this.currentDate = currentWeekSeeker;

  //then we seek in which week it is
  while(currentWeekSeeker>result[0].end){
    deltaWeekCount++;
    currentWeekSeeker = DateUtils.dateAdd(currentWeekSeeker,{day:-7});
  }
  result[deltaWeekCount].isCurrent = true;

  //console.log(result)
  this.currentWeekIndex = deltaWeekCount;

  return result;
}
ApiServer.types.TimetableBean.prototype.getWeek = function(date){
  var
    weekCount = this.recurrencyDescriptor.recurrencyInterval,
    endOfLastWeek=this.weeks[this.weeks.length-1].end;

  while(date>endOfLastWeek){
    date = DateUtils.dateAdd(date,{day:-7*weekCount})
  }
  for(let i=0;i<this.weeks.length;i++){
    if(date<=this.weeks[i].end){
      return this.weeks[i];
    }
  }
  console.log("week not found");
  return null;
}

ApiServer.types.ISettingsPerFamily.prototype.defaultReminderAsString = function(){
  return this.defaultReminderType==='NONE'?'':(this.defaultReminderUnit + '-' + this.defaultReminderValue)
}
Object.assign(ApiServer.types.RecipeIngredientBean.prototype,{
  fullname:function(){
    if(this.complementData===undefined){
      return this.name;
    }
    return this.name+", "+this.complementData
  }
})

export {mapMedia,decodeGiphy}